import createRoute      from '@widesk-ui/tools/createRoute';
import PartnershipModel from '@models/shop/PartnershipModel';

export default createRoute.dashboard('/partnerships', 'shop', 'PartnershipDashboard', PartnershipModel.localize());
